export default __webpack_public_path__ + "static/team-member-05-370x250-8ffdd275a7028612655ec9965d54f3ac.jpg";